import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { allowedLinks, generatePasswordHomeLink } from "@nxplatform/platform-settings/locale-setup.routes";
import { useQuery } from "../../hooks/query.hook.js";
const usePasswordRestore = ({
  tokenError,
  tokenLoaded,
  checkRestorePasswordToken
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const token = useQuery().get("token");
  useEffect(() => {
    if (pathname && token && pathname === allowedLinks.passwordRestore) {
      checkRestorePasswordToken(token);
    }
  }, [pathname]);
  useEffect(() => {
    if (history && tokenLoaded && tokenError) {
      navigate(generatePasswordHomeLink());
    }
  }, [tokenLoaded]);
};
export {
  usePasswordRestore
};
